var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VueSlickCarousel',_vm._b({},'VueSlickCarousel',_vm.settings,false),[_c('slide-one'),_c('slide-two'),_c('slide-three')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }